import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { Button } from 'shared/components';

const propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
  showFooterTermsAndConditionsModal: PropTypes.func.isRequired,
};

const TermsAndConditionsLink = ({
  intl,
  showFooterTermsAndConditionsModal,
}) => (
  <Fragment>
    &nbsp;|&nbsp;
    <Button
      testId="tos-link-button"
      buttonType="naked"
      label={ intl.formatMessage({
        id: 'tos.view.link',
        defaultMessage: '** Terms and conditions',
      }) }
      size="xsmall"
      onClick={ showFooterTermsAndConditionsModal }
    />
  </Fragment>
);

TermsAndConditionsLink.propTypes = propTypes;

export default TermsAndConditionsLink;
